// GIAO DIỆN TỔNG 2026-10 (07/10/2026) — chữ GIẢI THÍCH chỉ hiện khi cần. Người dùng: "đập đi xây mới": mọi đoạn giải thích / hướng dẫn
// (p.muted dưới tiêu đề, gợi ý dưới ô…) thành nút ⓘ cạnh tiêu đề / nhãn; hiện khi RÊ CHUỘT, khi FOCUS bằng bàn phím (Tab) và khi CHẠM (chạm lại
// để ẩn); nút có aria-describedby trỏ tới đoạn chữ. KHÔNG ẩn: lỗi, lý do bị CHẶN, cảnh báo vàng/đỏ, trạng thái chạy, số liệu.
//
// MỘT bộ theo dõi chung (như khung-mau.ts / cuon-bang.ts) — trang không phải sửa từng chỗ:
//  · đoạn chữ GIỮ NGUYÊN chỗ trong DOM (mã trang vẫn cập nhật được, test đọc textContent vẫn thấy) — chỉ thành bong bóng (popover="manual",
//    role="tooltip") ẩn mặc định; nút ⓘ chèn vào tiêu đề / nhãn gần nhất (nút KHÔNG có chữ — ký hiệu vẽ bằng CSS — nên chữ tiêu đề không đổi);
//  · trang muốn ép: lớp "giai-thich" (luôn thành ⓘ), "giu-hien" (không bao giờ ẩn); "ly-do-chan" = lý do bị chặn: vẫn HIỆN, gọn một dòng,
//    chi tiết đầy đủ ở ⓘ.

let soId = 0;
const MO = new Set<HTMLElement>(); // nút ⓘ đang mở bong bóng
const DINH = new WeakSet<HTMLElement>(); // nút mở bằng bấm/chạm (không tự ẩn khi rời chuột)
const henAn = new WeakMap<HTMLElement, number>();

/** Vùng KHÔNG bao giờ biến thành ⓘ: lỗi / cảnh báo / trạng thái / số liệu / bảng / sơ đồ / hộp thoại / ô điều khiển. */
const LOAI_TRU = [
  ".err-box", ".warn-box", ".info-box", ".err", ".warn", ".ok", ".running", ".live",
  "[role=alert]", "[role=status]", "[aria-live]", ".empty", "table", ".sdc", ".kb-buoc", ".modal", ".modal-wrap",
  ".giu-hien", ".card.bot", ".stat-tile", ".toolbar", "nav", "summary", "button", "a", ".tl-ds", "#toast",
].join(", ");
/** Câu trạng thái (đang tải, chưa có, không có…) — là TRẠNG THÁI, giữ hiện. */
const CAU_TRANG_THAI = /^(Đang|Chưa|Không|Hết|Còn|Đã|Lỗi|✓|✗|⚠|…)/;
const DO_DAI_TOI_THIEU = 50;

/** Đoạn này có phải chữ GIẢI THÍCH (đổi thành ⓘ) không. Thuần theo DOM — dùng chung cho test đơn vị. */
export function laGiaiThich(el: Element | null | undefined): boolean {
  if (!(el instanceof HTMLElement)) return false;
  if (el.dataset.gt) return false;
  if (el.classList.contains("giu-hien") || el.classList.contains("ly-do-chan")) return false;
  if (el.classList.contains("giai-thich")) return true;
  if (!el.matches("p.muted")) return false;
  if (el.closest(LOAI_TRU)) return false;
  // trạng thái mà mã / test đọc, hoặc đoạn có liên kết / nút / ô (ẩn đi thì đi Tab không tới được hành động) → giữ hiện
  if (el.dataset.testid || el.querySelector("[data-testid], a, input, select, textarea, button")) return false;
  const chu = (el.textContent ?? "").replace(/\s+/g, " ").trim();
  if (chu.length < DO_DAI_TOI_THIEU) return false;
  if (CAU_TRANG_THAI.test(chu)) return false;
  if (/\s·\s/.test(chu)) return false; // dòng số liệu "a · b · c"
  return true;
}

const LA_TIEU_DE = /^H[1-4]$/;

/** Tiêu đề / nhãn để gắn ⓘ cho đoạn `el`: tiêu đề ngay trước (bỏ qua các bong bóng khác), nhãn của ô, tiêu đề của thẻ. */
export function timChoGan(el: HTMLElement): HTMLElement | null {
  let s = el.previousElementSibling;
  while (s && (s.classList.contains("gt-bong") || s.classList.contains("gt-dong"))) s = s.previousElementSibling;
  if (s instanceof HTMLElement) {
    if (LA_TIEU_DE.test(s.tagName)) return s;
    const f = s.firstElementChild;
    if (f instanceof HTMLElement && LA_TIEU_DE.test(f.tagName)) return f; // hàng đầu thẻ: tiêu đề + nút
    if (s.tagName === "SUMMARY") return s;
    if (s.tagName === "LABEL") { const sp = s.querySelector(":scope > span"); if (sp instanceof HTMLElement) return sp; } // gợi ý ngay dưới ô
  }
  const nhan = el.closest("label");
  if (nhan) { const sp = nhan.querySelector(":scope > span"); if (sp instanceof HTMLElement) return sp; }
  const the = el.closest(".card");
  if (the) {
    const f = the.firstElementChild;
    if (f instanceof HTMLElement) {
      if (LA_TIEU_DE.test(f.tagName) || f.tagName === "SUMMARY") return f;
      const g = f.firstElementChild;
      if (g instanceof HTMLElement && LA_TIEU_DE.test(g.tagName)) return g;
    }
  }
  return null;
}

function idCua(el: HTMLElement): string {
  if (!el.id) el.id = `gt-${++soId}`;
  return el.id;
}

/** Nút ⓘ đang trỏ tới đoạn có id `id` (nếu còn trong trang). */
function nutCua(id: string): HTMLElement | null {
  for (const n of document.querySelectorAll<HTMLElement>(".gt-nut")) {
    if ((n.getAttribute("aria-describedby") ?? "").split(/\s+/).includes(id)) return n;
  }
  return null;
}

function dsBong(nut: HTMLElement): HTMLElement[] {
  return (nut.getAttribute("aria-describedby") ?? "").split(/\s+/).filter(Boolean)
    .map((id) => document.getElementById(id)).filter((e): e is HTMLElement => e instanceof HTMLElement);
}

function coPopover(el: HTMLElement): boolean {
  return typeof (el as HTMLElement & { showPopover?: unknown }).showPopover === "function";
}

function datViTri(nut: HTMLElement, bongs: HTMLElement[]): void {
  const r = nut.getBoundingClientRect();
  const W = document.documentElement.clientWidth || innerWidth;
  let y = r.bottom + 6;
  for (const b of bongs) {
    b.style.left = "0px"; b.style.top = "0px";
    const w = b.offsetWidth, hh = b.offsetHeight;
    const x = Math.max(8, Math.min(r.left - 10, W - w - 8));
    let top = y;
    if (bongs.length === 1 && top + hh > innerHeight - 8 && r.top - hh - 6 >= 8) top = r.top - hh - 6; // không đủ chỗ dưới → lên trên
    b.style.left = `${Math.round(x)}px`;
    b.style.top = `${Math.round(top)}px`;
    y = top + hh + 4;
  }
}

function moBong(nut: HTMLElement, dinh: boolean): void {
  clearTimeout(henAn.get(nut));
  const bongs = dsBong(nut);
  if (!bongs.length) return;
  // chỉ một nút mở một lúc (trừ nút đang được bấm giữ)
  for (const k of [...MO]) if (k !== nut) dongBong(k);
  for (const b of bongs) {
    if (b.dataset.gt === "ban-sao") b.textContent = ([...document.querySelectorAll<HTMLElement>("[data-gt-ban-sao]")].find((x) => x.dataset.gtBanSao === b.id)?.textContent ?? "").trim();
    b.classList.add("gt-mo");
    if (coPopover(b) && !b.matches(":popover-open")) { try { b.showPopover(); } catch { /* đã mở / phần tử rời trang */ } }
  }
  if (dinh) DINH.add(nut);
  nut.setAttribute("aria-expanded", "true");
  MO.add(nut);
  datViTri(nut, bongs);
}

function dongBong(nut: HTMLElement): void {
  clearTimeout(henAn.get(nut));
  for (const b of dsBong(nut)) {
    b.classList.remove("gt-mo");
    if (coPopover(b) && b.matches(":popover-open")) { try { b.hidePopover(); } catch { /* bỏ */ } }
  }
  DINH.delete(nut);
  nut.setAttribute("aria-expanded", "false");
  MO.delete(nut);
}

function anSau(nut: HTMLElement): void {
  clearTimeout(henAn.get(nut));
  henAn.set(nut, window.setTimeout(() => { if (!DINH.has(nut)) dongBong(nut); }, 180));
}

function trongBong(nut: HTMLElement, x: EventTarget | null): boolean {
  return x instanceof Node && dsBong(nut).some((b) => b.contains(x));
}

/** Tạo nút ⓘ (không có chữ: ký hiệu vẽ bằng CSS → textContent của tiêu đề / dòng lý do không đổi). */
function taoNut(): HTMLButtonElement {
  const nut = document.createElement("button");
  nut.type = "button";
  nut.className = "gt-nut";
  nut.dataset.testid = "gt-nut";
  nut.setAttribute("aria-label", "Giải thích");
  nut.setAttribute("aria-expanded", "false");
  nut.addEventListener("pointerenter", (e) => { if (e.pointerType === "mouse") moBong(nut, false); });
  nut.addEventListener("pointerleave", (e) => { if (e.pointerType === "mouse") anSau(nut); });
  nut.addEventListener("focus", () => { if (nut.matches(":focus-visible")) moBong(nut, false); });
  nut.addEventListener("blur", (e) => { if (!trongBong(nut, e.relatedTarget)) { DINH.delete(nut); anSau(nut); } });
  nut.addEventListener("click", (e) => {
    e.preventDefault(); e.stopPropagation(); // nút nằm trong <summary>/<label>: không mở/đóng details, không bấm ô
    if (MO.has(nut) && DINH.has(nut)) dongBong(nut);
    else moBong(nut, true);
  });
  return nut;
}

function ganBong(b: HTMLElement, nut: HTMLElement): void {
  if (b.dataset.gtNghe) return;
  b.dataset.gtNghe = "1";
  b.addEventListener("pointerenter", () => { for (const k of MO) if (dsBong(k).includes(b)) clearTimeout(henAn.get(k)); });
  b.addEventListener("pointerleave", (e) => { if (e.pointerType !== "mouse") return; for (const k of [...MO]) if (dsBong(k).includes(b)) anSau(k); });
  b.addEventListener("focusout", (e) => { if (e.relatedTarget !== nut && !trongBong(nut, e.relatedTarget)) anSau(nut); });
}

function thanhBong(el: HTMLElement): void {
  el.classList.add("gt-bong");
  el.setAttribute("role", "tooltip");
  if (coPopover(el)) el.setAttribute("popover", "manual");
}

/** Gắn đoạn giải thích `el` vào nút ⓘ (tạo nút nếu chỗ gắn chưa có). */
function ganVaoNut(el: HTMLElement): void {
  const id = idCua(el);
  if (nutCua(id)) return;
  const cho = timChoGan(el);
  let nut: HTMLElement | null = null;
  if (cho) {
    nut = cho.querySelector(":scope > .gt-nut");
    if (!nut) { nut = taoNut(); cho.append(nut); }
  } else {
    // không có tiêu đề / nhãn gần: ⓘ đứng tại chỗ đoạn chữ
    const dong = document.createElement("span");
    dong.className = "gt-dong";
    nut = taoNut();
    dong.append(nut);
    el.before(dong);
  }
  const ids = (nut.getAttribute("aria-describedby") ?? "").split(/\s+/).filter(Boolean);
  if (!ids.includes(id)) nut.setAttribute("aria-describedby", [...ids, id].join(" "));
  ganBong(el, nut);
}

/** Lý do bị CHẶN: vẫn hiện (gọn một dòng — style.css .ly-do-chan), ⓘ ở cuối dòng mở câu đầy đủ (bản sao, cập nhật mỗi lần mở). */
function lyDoChan(el: HTMLElement): void {
  const id = idCua(el);
  let bong = [...document.querySelectorAll<HTMLElement>("[data-gt-ban-sao-cua]")].find((b) => b.dataset.gtBanSaoCua === id) ?? null;
  if (!bong || !bong.isConnected) {
    bong = document.createElement("div");
    bong.className = "gt-bong";
    bong.dataset.gt = "ban-sao";
    bong.dataset.gtBanSaoCua = id;
    bong.id = `${id}-day-du`;
    thanhBong(bong);
    el.after(bong);
  }
  el.dataset.gtBanSao = bong.id;
  let nut = el.querySelector<HTMLElement>(":scope > .gt-nut");
  if (!nut) { nut = taoNut(); nut.setAttribute("aria-label", "Xem lý do đầy đủ"); el.append(nut); }
  nut.setAttribute("aria-describedby", bong.id);
  ganBong(bong, nut);
}

/** Quét một gốc: đổi chữ giải thích thành ⓘ; dựng lại nút nếu trang vừa vẽ lại tiêu đề. Gọi lại nhiều lần không sao (bất biến). */
export function quetGiaiThich(goc: ParentNode, chiXet?: Iterable<HTMLElement>): void {
  for (const el of chiXet ?? goc.querySelectorAll<HTMLElement>("p.muted, .giai-thich")) {
    if (laGiaiThich(el)) { el.dataset.gt = "1"; thanhBong(el); }
  }
  for (const el of goc.querySelectorAll<HTMLElement>('[data-gt="1"]')) ganVaoNut(el);
  for (const el of goc.querySelectorAll<HTMLElement>(".ly-do-chan")) lyDoChan(el);
  // trang vừa gỡ đoạn giải thích mà giữ tiêu đề → gỡ luôn ⓘ không còn gì để hiện
  for (const nut of goc.querySelectorAll<HTMLElement>(".gt-nut")) {
    if (dsBong(nut).length) continue;
    dongBong(nut);
    const dong = nut.parentElement?.classList.contains("gt-dong") ? nut.parentElement : null;
    (dong ?? nut).remove();
  }
}

const DOAN = "p.muted, .giai-thich";
/** Các đoạn cần xét lại sau một lượt thay đổi DOM: đoạn trong phần vừa THÊM, và đoạn chứa nơi vừa đổi con (trang thay chữ trong đoạn). */
export function ungVien(goc: Node, ds: Iterable<Pick<MutationRecord, "target" | "addedNodes">>, chon = DOAN): Set<HTMLElement> {
  const s = new Set<HTMLElement>();
  for (const r of ds) {
    const t = r.target instanceof Element ? r.target : r.target.parentElement;
    const p = t?.closest<HTMLElement>(chon);
    if (p && goc.contains(p)) s.add(p);
    for (const n of r.addedNodes) {
      if (!(n instanceof HTMLElement)) continue;
      if (n.matches(chon)) s.add(n);
      if (n.firstElementChild) for (const e of n.querySelectorAll<HTMLElement>(chon)) s.add(e);
    }
  }
  return s;
}

/** Phần tử bị gỡ có mang đoạn giải thích / bong bóng không (→ có thể còn ⓘ mồ côi cần gỡ). */
const coBongBiGo = (ds: Iterable<Pick<MutationRecord, "removedNodes">>): boolean => {
  for (const r of ds) for (const n of r.removedNodes) if (n instanceof Element && (n.matches("[data-gt], .gt-bong") || n.querySelector("[data-gt], .gt-bong"))) return true;
  return false;
};
/** Có đoạn giải thích nào (đang trong trang) mất nút ⓘ không — vd trang vẽ lại tiêu đề mà giữ đoạn. Chỉ duyệt các đoạn đã đổi (ít), không quét cả trang. */
const coBongMoCoi = (goc: ParentNode): boolean => {
  for (const el of goc.querySelectorAll<HTMLElement>('[data-gt="1"]')) if (!nutCua(el.id)) return true;
  return false;
};

/**
 * Bản dùng cho bộ theo dõi (07/10/2026): chỉ xét phần vừa đổi. Quét chung (gắn lại ⓘ, gỡ ⓘ mồ côi) chỉ khi CẦN: vừa đổi đoạn mới, vừa gỡ phần
 * tử mang bong bóng, hoặc có đoạn đã đổi bị mất nút (tiêu đề vẽ lại). Kết quả như quetGiaiThich(goc) quét toàn bộ.
 */
export function quetThayDoi(goc: ParentNode & Node, ds: MutationRecord[]): void {
  let moi = false;
  for (const el of ungVien(goc, ds)) if (laGiaiThich(el)) { el.dataset.gt = "1"; thanhBong(el); moi = true; }
  for (const el of ungVien(goc, ds, ".ly-do-chan")) lyDoChan(el);
  const daGt = goc.querySelector('[data-gt="1"]') !== null;
  if (moi || coBongBiGo(ds) || (daGt && coBongMoCoi(goc))) quetGiaiThich(goc, []);
}

let daBat = false;
/** Bật một lần lúc khởi động (app.ts) trên #main. */
export function batGiaiThich(goc: HTMLElement | null = document.getElementById("main")): void {
  if (daBat || !goc) return;
  daBat = true;
  // Đổi NGAY trong lượt MutationObserver (trước khi vẽ) → không có khung hình nào đoạn giải thích hiện rồi mới ẩn.
  // (07/10/2026, đo trên trang Bot 1000 bot — E2E boss-web W36) chỉ xét đoạn p.muted / .giai-thich NẰM TRONG phần vừa thêm hoặc vừa đổi chữ, không
  // quét lại mọi p.muted của cả trang mỗi lần chèn một thẻ (trước: mỗi thẻ bot chèn vào → closest() trên hàng nghìn đoạn → chậm theo bình phương).
  new MutationObserver((ds) => quetThayDoi(goc, ds)).observe(goc, { childList: true, subtree: true });
  quetGiaiThich(goc);
  // Esc: đóng bong bóng (chặn mặc định → app.ts không đóng thêm hộp thoại bên dưới)
  window.addEventListener("keydown", (e) => {
    if (e.key !== "Escape" || !MO.size) return;
    for (const k of [...MO]) dongBong(k);
    e.preventDefault();
  }, true);
  // chạm / bấm ra ngoài → đóng bong bóng đang ghim
  document.addEventListener("pointerdown", (e) => {
    for (const k of [...MO]) if (!(e.target instanceof Node) || (!k.contains(e.target) && !trongBong(k, e.target))) dongBong(k);
  }, true);
  const theoDoi = (): void => { for (const k of MO) { if (k.isConnected) datViTri(k, dsBong(k)); else dongBong(k); } };
  window.addEventListener("scroll", theoDoi, { passive: true, capture: true });
  window.addEventListener("resize", theoDoi);
  window.addEventListener("hashchange", () => { for (const k of [...MO]) dongBong(k); });
}
